<template>
  <EditarBase
    :itemAtual="itemAtual"
    :recursoInicial="recursoInicial"
    nomeSingular="FuncionarioFolhaPagamentoVerba"
    nomePlural="FuncionarioFolhaPagamentoVerbas"
    :submitPersonalizado="calculoFolhaContratado"
    @recurso="recurso = $event"
    @submitSuccess="emitSubmitSuccess"
    @submitError="emitSubmitError"
    @closeModalEdit="closeModalEdit"
  >
    <v-col cols="12">
      <v-row>
        <v-col cols="2" md="2">
          <span class="opacity-5 text-dark">
            {{ $t("Verba") }}
          </span>
          <v-text-field
            v-model="recurso.verba"
            :label="$t('Verba')"
            name="descricao"
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          >
          </v-text-field>
        </v-col>
        <v-col cols="10" md="10">
          <span class="opacity-5 text-dark">
            {{ $t("Descricao") }}
          </span>
          <v-text-field
            v-model="recurso.descricaoVerba"
            :label="$t('Descricao')"
            name="descricao"
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          >
          </v-text-field>
        </v-col>

        <!-- Sem o módulo CFP: indicadores simples da folha importada -->
        <template v-if="!calculoFolhaContratado">
          <v-col cols="12" md="3">
            <span class="opacity-5 text-dark">
              {{ $t("Tipo") }}
            </span>
            <v-select
              v-model="recurso.tipoVerba"
              :items="itensTipoVerba"
              :label="$t('Tipo')"
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
              solo
            ></v-select>
          </v-col>

          <v-col cols="12" md="2">
            <v-checkbox v-model="recurso.base13">
              <template v-slot:label>
                {{ $t("base13") }}
              </template>
            </v-checkbox>
          </v-col>
          <v-col cols="12" md="2">
            <v-checkbox v-model="recurso.baseFerias">
              <template v-slot:label>
                {{ $t("baseFerias") }}
              </template>
            </v-checkbox>
          </v-col>
          <v-col cols="12" md="2">
            <v-checkbox v-model="recurso.baseAvisoPrevio">
              <template v-slot:label>
                {{ $t("baseAvisoPrevio") }}
              </template>
            </v-checkbox>
          </v-col>
          <v-col cols="12" md="2">
            <v-checkbox v-model="recurso.baseINSS">
              <template v-slot:label>
                {{ $t("baseINSS") }}
              </template>
            </v-checkbox>
          </v-col>
          <v-col cols="12" md="2">
            <v-checkbox v-model="recurso.baseIRRF">
              <template v-slot:label>
                {{ $t("baseIRRF") }}
              </template>
            </v-checkbox>
          </v-col>
          <v-col cols="12" md="2">
            <v-checkbox v-model="recurso.baseFGTS">
              <template v-slot:label>
                {{ $t("baseFGTS") }}
              </template>
            </v-checkbox>
          </v-col>
          <v-col cols="12" md="4">
            <v-checkbox v-model="recurso.esocialAjustada">
              <template v-slot:label>
                Rubrica do eSocial já conferida/ajustada
              </template>
            </v-checkbox>
            <div class="text-caption text--secondary mt-n4 ml-8">
              Marcada, a integração não sobrescreve esta classificação.
            </div>
          </v-col>
        </template>

        <!-- Com o módulo CFP: classificação eSocial e configuração do cálculo -->
        <v-col v-if="calculoFolhaContratado && recurso.id" cols="12">
          <ConfiguracaoCalculoVerba ref="calculo" :verba-id="recurso.id" />
        </v-col>

        <v-col cols="12" md="12">
          <CriaSuperSet
            :podeEditarRecursoFinal="true"
            :podeExcluirRecursoFinal="false"
            @recursos="recurso.contasContabil = $event"
            :usaRecursoBase="false"
            :payload="recurso.contasContabil"
            :pesquisa="false"
            textoBotaoCadastro="Nova_conta_contabil"
            tituloFinais="Conta_contabil"
            subtituloFinais="Clique_para_adicionar"
            :headersFinais="[
              {
                text: this.$t('Conta_contabil'),
                value: 'contaContabil',
                sortable: 'true',
              },
              {
                text: this.$t('Tipo'),
                value: 'tipoContabil',
                sortable: 'true',
              },
              {
                text: this.$t('Responsavel'),
                value: 'reponsavel.nome',
                sortable: 'true',
              },

              {
                text: this.$t('Data_de_alteracao'),
                value: 'dtAlteracao',
                sortable: 'true',
              },

              { text: this.$t('Acoes'), value: 'actions', sortable: 'false' },
            ]"
          >
            <template v-slot:default="slotProps">
              <!-- Form cria recurso final -->

              <v-col cols="12" md="12">
                <v-text-field
                  :rules="rule_required"
                  v-model="slotProps.recursoFinalAtual.contaContabil"
                  :label="$t('Conta_contabil')"
                  name="contasContabil"
                  type="text"
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <span class="opacity-5 text-dark">
                  {{ $t("Tipo") }}
                </span>
                <v-select
                  v-model="slotProps.recursoFinalAtual.tipoContabil"
                  :items="itensTipoContabil"
                  :label="$t('Tipo')"
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                ></v-select>
              </v-col>
            </template>
            <template v-slot:formEditaRecursoFinal="slotProps">
              <v-col cols="12" md="12">
                <v-text-field
                  :rules="rule_required"
                  v-model="slotProps.recursoFinalAtual.contaContabil"
                  :label="$t('Conta_contabil')"
                  name="contasContabil"
                  type="text"
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <span class="opacity-5 text-dark">
                  {{ $t("Tipo") }}
                </span>
                <v-select
                  v-model="slotProps.recursoFinalAtual.tipoContabil"
                  :items="itensTipoContabil"
                  :label="$t('Tipo')"
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                ></v-select>
              </v-col>
            </template>
          </CriaSuperSet>
        </v-col>
      </v-row>
    </v-col>
  </EditarBase>
</template>

<script>
import EditarBase from "@/components/base/Crud/EditarBase";

import CriaSuperSet from "@/components/base/proprios/CriaSuperset.vue";
import moduloCalculoFolha from "@/components/pessoal/folha-calculo/moduloCalculoFolha";
import ConfiguracaoCalculoVerba from "./ConfiguracaoCalculoVerba.vue";
import FuncionarioFolhaPagamentoVerbaDataService from "@/services/pessoal/FuncionarioFolhaPagamentoVerbaDataService";
const DataService = FuncionarioFolhaPagamentoVerbaDataService;

import createNumberMask from "text-mask-addons/dist/createNumberMask";
const currencyMask = createNumberMask({
  prefix: "R$",
  allowDecimal: true,
  includeThousandsSeparator: true,
  allowNegative: false,
});

export default {
  props: {
    itemAtual: { type: Object, required: false, default: null },
    recursoInicial: { type: Object, required: false, default: null },
  },
  name: "EditarFuncionarioFolhaPagamentoVerba",
  components: { EditarBase, CriaSuperSet, ConfiguracaoCalculoVerba },
  mixins: [moduloCalculoFolha],
  data() {
    return {
      DataService: DataService,
      submited: false,
      mask: currencyMask,

      recurso: {
        id: null,
        descricao: "",
        statusComum: "",
        salarioBase: "",
        verba: "",
        descricaoVerba: "",
        tipoVerba: "",
        base13: false,
        baseFerias: false,
        baseAvisoPrevio: false,
        baseINSS: false,
        baseIRRF: false,
        baseFGTS: false,
        esocialAjustada: false,
        contasContabil: [],
      },
      salBase: "12",
      errors: [],

      itensTipoVerba: [
        { text: this.$t("PROVENTO"), value: "PROVENTO" },
        { text: this.$t("DESCONTO"), value: "DESCONTO" },
      ],

      itensTipoContabil: [
        { text: this.$t("CREDITO"), value: "CREDITO" },
        { text: this.$t("DEBITO"), value: "DEBITO" },
      ],
    };
  },

  computed: {
    salarioBaseSemMascara: function () {
      let str = this.recurso.salarioBase;

      str = str.toString();
      str = str.replace("$", "");
      str = str.replace(/,/gi, "");
      str = str.replace(/([A-z])/, "");

      console.log(str);
      return str;
    },
  },

  mounted() {
    //this.getRecurso();
  },

  methods: {
    emitSubmitSuccess(recursoAtualizado = this.recurso) {
      this.$emit("submitSuccess", recursoAtualizado);
    },
    emitSubmitError() {
      this.$emit("submitError");
    },
    closeModalEdit() {
      this.$emit("closeModalEdit");
    },
    // Com o módulo CFP o EditarBase usa este envio (submitPersonalizado): a verba, a configuração do cálculo
    // e as contas contábeis são gravadas juntas. Sem o módulo, o EditarBase segue com o PUT de sempre.
    async submitForm() {
      const calculo = this.$refs.calculo;
      if (!calculo || !calculo.pronto)
        throw [
          {
            fieldName: "Verba",
            message:
              (calculo && calculo.erro) ||
              "Aguarde o carregamento da configuração do cálculo.",
          },
        ];
      try {
        await DataService.updateCalculo({
          ...calculo.dados(),
          id: this.recurso.id,
          descricao: this.recurso.descricaoVerba,
          contasContabil: (this.recurso.contasContabil || []).map((c) => ({
            contaContabil: c.contaContabil,
            tipoContabil: c.tipoContabil,
          })),
        });
      } catch (error) {
        const dados = (error && error.response && error.response.data) || {};
        throw Array.isArray(dados.errors) && dados.errors.length
          ? dados.errors
          : [
              {
                fieldName: "Verba",
                message: dados.message || "Não foi possível salvar a verba.",
              },
            ];
      }
      // A listagem atualiza a linha com o retorno: devolve a verba como ficou gravada
      // (se a releitura falhar, o EditarBase usa o próprio formulário).
      try {
        const r = await DataService.find(this.recurso.id);
        return { data: r.data };
      } catch (e) {
        return { data: null };
      }
    },

    getRecurso() {
      DataService.find(this.recurso.id)
        .then((response) => {
          this.recurso.id = response.data.id;
          this.recurso.salarioBase = response.data.salarioBase;
          this.recurso.descricao = response.data.descricao;
          this.recurso.statusComum = response.data.statusComum;
        })
        .catch((error) => {
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
          console.log(error);
          this.errors.push({ field: "ID", message: "Usuário não encontrado" });
        });
    },

    mascaraMonetaria() {},
  },
};
</script>

<style scoped></style>
